import styled from 'styled-components';

export const Backdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(51, 51, 51, 0.7);
`;
export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 370px;
  outline: 0;
`;
export const StyledModal = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #efefef;
  color: #1a1a1a;
  width: 100%;
  height: 100%;
  padding: 0 20px;
`;
export const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 70px;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #efefef;
  padding-right: 36px;
`;
export const Footer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  border-radius: 0 0 5px 5px;
  border-top: 1px solid #efefef;
`;
export const Content = styled.div`
  position: relative;
  flex: 1;
`;
